/* Aquanova theme script. Prices are never calculated or formatted here:
   every price string comes pre-formatted from Liquid via data attributes. */
(function () {
  'use strict';

  /* ---------- Product: variant + bundle ---------- */
  function initBuyBox(root) {
    var form = root.querySelector('[data-product-form]');
    if (!form) return;
    var qtyInput = form.querySelector('[data-qty-input]');
    var priceMain = root.querySelector('[data-price-display]');
    var priceEach = root.querySelector('[data-price-each]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyLabel = document.querySelector('[data-sticky-label]');

    function currentVariantId() {
      var checked = form.querySelector('[data-variant-option]:checked');
      return checked ? checked.value : form.getAttribute('data-default-variant');
    }
    function currentBundle() {
      return root.querySelector('[data-bundle-option]:checked');
    }

    function refresh() {
      var vid = currentVariantId();
      /* copy the Liquid-made strings for this variant into every bundle row */
      root.querySelectorAll('[data-bundle-option]').forEach(function (opt) {
        var box = opt.parentNode;
        var total = box.querySelector('[data-bundle-total]');
        var each = box.querySelector('[data-bundle-each]');
        if (total) total.textContent = opt.getAttribute('data-total-' + vid) || total.textContent;
        if (each) each.textContent = opt.getAttribute('data-each-' + vid) || each.textContent;
      });
      var b = currentBundle();
      if (!b) return;
      /* only the separate quantity input changes; the variant id input is never touched */
      if (qtyInput) qtyInput.value = b.getAttribute('data-qty');
      var t = b.getAttribute('data-total-' + vid);
      var e = b.getAttribute('data-each-' + vid);
      if (priceMain && t) priceMain.textContent = t;
      if (priceEach && e) priceEach.textContent = e;
      if (stickyPrice && t) stickyPrice.textContent = t;
      if (stickyLabel) stickyLabel.textContent = b.getAttribute('data-label') || '';
    }

    root.addEventListener('change', function (ev) {
      var el = ev.target;
      if (el.matches('[data-bundle-option]')) refresh();
      if (el.matches('[data-variant-option]')) {
        refresh();
        var slide = el.getAttribute('data-show-slide');
        if (slide) showSlide(document.querySelector('[data-gallery]'), parseInt(slide, 10));
      }
    });
    refresh();
  }

  /* ---------- Gallery ---------- */
  function showSlide(gallery, index) {
    if (!gallery) return;
    var slides = gallery.querySelectorAll('[data-slide]');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    if (!slides.length) return;
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    slides.forEach(function (s, i) {
      s.classList.toggle('is-active', i === index);
      s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });
    thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    gallery.setAttribute('data-current', index);
  }
  function initGallery(g) {
    g.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { showSlide(g, parseInt(t.getAttribute('data-thumb'), 10)); });
    });
    var stage = g.querySelector('[data-stage]');
    if (stage) {
      var x0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var cur = parseInt(g.getAttribute('data-current') || '0', 10);
        if (Math.abs(dx) > 40) showSlide(g, dx < 0 ? cur + 1 : cur - 1);
        x0 = null;
      }, { passive: true });
    }
    showSlide(g, 0);
  }

  /* ---------- Mobile sticky buy bar: IntersectionObserver ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-sticky-buy]');
    var anchor = document.querySelector('[data-atc]');
    if (!bar || !anchor) return;
    function setVisible(show) {
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          setVisible(show);
        });
      }, { threshold: 0 });
      observer.observe(anchor);
    } else {
      function update() {
        var r = anchor.getBoundingClientRect();
        setVisible(r.bottom < 0);
      }
      window.addEventListener('scroll', update, { passive: true });
      update();
    }
  }

  /* ---------- Localization select auto-submit ---------- */
  function initAutosubmit() {
    document.querySelectorAll('[data-autosubmit]').forEach(function (s) {
      s.addEventListener('change', function () { if (s.form) s.form.submit(); });
    });
  }

  /* ---------- Cart: quantity change submits update ---------- */
  function initCart() {
    var f = document.querySelector('[data-cart-form]');
    if (!f) return;
    f.querySelectorAll('[data-cart-qty]').forEach(function (q) {
      q.addEventListener('change', function () { f.submit(); });
    });
  }

  /* ---------- Tasteful scroll reveals ---------- */
  function initMotion() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var targets = document.querySelectorAll('.split__media, .split__copy, .feature, .gift-card, .pair__item, .step, .guarantee > *, .facts .fact, .faq__item, .pdp__grid > *');
    if (!targets.length) return;
    document.documentElement.classList.add('aq-motion-ready');
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('aq-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    targets.forEach(function (el) {
      el.classList.add('aq-reveal');
      observer.observe(el);
    });
  }


  /* ---------- Header depth on scroll ---------- */
  function initHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var ticking = false;
    function update() {
      ticking = false;
      header.classList.toggle('is-scrolled', window.scrollY > 16);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
  }

  /* ---------- FAQ: keep the section tidy ---------- */
  function initFaq() {
    document.querySelectorAll('.faq').forEach(function (faq) {
      faq.querySelectorAll('[data-faq]').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          faq.querySelectorAll('[data-faq]').forEach(function (other) {
            if (other !== item && other.open) other.open = false;
          });
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-buy-box]').forEach(initBuyBox);
    document.querySelectorAll('[data-gallery]').forEach(initGallery);
    initSticky();
    initAutosubmit();
    initCart();
    initHeader();
    initFaq();
    initMotion();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
